export default __webpack_public_path__ + "44c34262e14214d4a546e151766269e8.svg";